/** Jetons de design extraits du prototype Claude Design. */
export const colors = {
  navy: '#233A50',
  navySoft: '#33506B',
  slate: '#4A5560',
  grey: '#8A95A3',
  greyMuted: '#6B7785',
  border: '#E4E8ED',
  borderInput: '#DDE2E7',
  divider: '#F0F2F5',
  surface: '#FFFFFF',
  surfaceAlt: '#F8F9FB',
  canvas: '#F4F6F9',
  pink: '#D67F9E',
  blue: '#7FB3D5',
  green: '#5CA989',
  amber: '#E0A552',
  danger: '#C6564F',
  dangerText: '#8A4A44',
  warnText: '#8A5B22',
  successText: '#2E6B4E',
} as const;

export const fonts = {
  display: "'Baloo 2', sans-serif",
  body: "'Nunito', sans-serif",
} as const;

/** Couple [fond, texte] par statut, aligné sur le prototype. */
export const statusPalette: Record<string, readonly [string, string]> = {
  pending: ['#E0A55222', '#8A5B22'],
  approved: ['#5CA98922', '#2E6B4E'],
  rejected: ['#C6564F22', '#8A4A44'],
  active: ['#5CA98922', '#2E6B4E'],
  suspended: ['#8A95A322', '#5A6673'],
  draft: ['#8A95A322', '#5A6673'],
  published: ['#5CA98922', '#2E6B4E'],
  disabled: ['#C6564F22', '#8A4A44'],
  inactive: ['#8A95A322', '#5A6673'],
};

export const statusLabels: Record<string, string> = {
  pending: 'En attente',
  approved: 'Approuvé',
  rejected: 'Rejeté',
  active: 'Active',
  suspended: 'Suspendue',
  draft: 'Brouillon',
  published: 'Publié',
  disabled: 'Désactivé',
};

export const PAGE_SIZE = 10;

const numberFormatter = new Intl.NumberFormat('fr-FR');

export function formatNumber(value: number): string {
  return numberFormatter.format(value);
}

export function formatFcfa(value: number): string {
  return `${numberFormatter.format(value)} FCFA`;
}
